export const SEND_TO_SOC_SUCCESS = 'SEND_TO_SOC_SUCCESS';
export const SEND_TO_ANALYSIS_SUCCESS = 'SEND_TO_ANALYSIS_SUCCESS';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const VERIFY_FILE_SUCCESS = 'VERIFY_FILE_SUCCESS';
export const QUARANTINE_FILE_SUCCESS = 'QUARANTINE_FILE_SUCCESS';
export const UNQUARANTINE_FILE_SUCCESS = 'UNQUARANTINE_FILE_SUCCESS';
export const KILL_PROCESS_SUCCESS = 'KILL_PROCESS_SUCCESS';
export const ENABLE_USER_SUCCESS = 'ENABLE_USER_SUCCESS';
export const DISABLE_USER_SUCCESS = 'DISABLE_USER_SUCCESS';
export const SCAN_HOST_SUCCESS = 'SCAN_HOST_SUCCESS';
export const SHUT_DOWN_SUCCESS = 'SHUT_DOWN_SUCCESS';
export const RESTART_SUCCESS = 'RESTART_SUCCESS';
export const CHANGE_IP_SUCCESS = 'CHANGE_IP_SUCCESS';
export const DISABLE_ALL_NICS_SUCCESS = 'DISABLE_ALL_NICS_SUCCESS';
export const RUN_COMMAND_SUCCESS = 'RUN_COMMAND_SUCCESS';
export const STOP_SERVICE_SUCCESS = 'STOP_SERVICE_SUCCESS';
export const STOP_AND_DELETE_SERVICE_SUCCESS = 'STOP_AND_DELETE_SERVICE_SUCCESS';
export const BLOCK_TRAFFIC_SUCCESS = 'BLOCK_TRAFFIC_SUCCESS';
export const GET_HOSTSGROUPS_SUCCESS = 'GET_HOSTSGROUPS_SUCCESS';
export const GET_HOSTS_TO_MATCH_SUCCESS = 'GET_HOSTS_TO_MATCH_SUCCESS';
export const GET_ALL_OS_SUCCESS = 'GET_ALL_OS_SUCCESS';
export const SAVE_GROUP_SUCCESS = 'SAVE_GROUP_SUCCESS';
export const SAVE_AUTOREMEDIATION_SUCCESS = 'SAVE_AUTOREMEDIATION_SUCCESS';
export const UPDATE_CUSTOM_REM_FOR_ENTITY = 'UPDATE_CUSTOM_REM_FOR_ENTITY';
export const UPDATE_WEB_API_CUSTOM_REMEDIATIONS_FOR_ENTITY = 'UPDATE_WEB_API_CUSTOM_REMEDIATIONS_FOR_ENTITY';
export const UPDATE_PLAYBOOK_ACTIONS = 'UPDATE_PLAYBOOK_ACTIONS';
export const GET_HOST_DETAILS = 'GET_HOST_DETAILS';
